import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ICourseSpecialisationsMetadata {
  id?: string;
  title?: string;
  desktop_title_text_color?: string;
  mobile_variant_1_title_text_color?: string;
  mobile_variant_2_title_text_color?: string;
  sub_title?: string;
  desktop_sub_title_text_color?: string;
  mobile_variant_2_sub_title_text_color?: string;
  description?: string;
  desktop_description_text_color?: string;
  mobile_variant_1_description_text_color?: string;
  mobile_variant_2_description_text_color?: string;
  desktop_icon?: string;
  desktop_icon_alt?: string;
  mobile_variant_1_icon?: string;
  mobile_variant_1_icon_alt?: string;
  desktop_hover_icon?: string;
  desktop_hover_icon_alt?: string;
  desktop_active_card_color?: string;
  desktop_inactive_card_color?: string;
  desktop_gradient_angle?: string;
  desktop_gradient_start_color?: string;
  desktop_gradient_end_color?: string;
  mobile_variant_1_title_card_color?: string;
  mobile_variant_1_description_card_color?: string;
  mobile_variant_2_card_color?: string;
  mobile_variant_2_gradient_angle?: string;
  mobile_variant_2_gradient_start_color?: string;
  mobile_variant_2_gradient_end_color?: string;
  mobile_variant_2_accordion_element_color?: string;
}

export interface ICourseSpecialisations {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  desktop_background_color?: string;
  mobile_variant_1_background_color?: string;
  mobile_variant_2_background_color?: string;
  mobile_variant?: "1" | "2";
  mobile_variant_1_left_nav_icon?: string;
  mobile_variant_1_left_nav_icon_alt?: string;
  mobile_variant_1_right_nav_icon?: string;
  mobile_variant_1_right_nav_icon_alt?: string;
  mobile_variant_2_top_arrow_icon?: string;
  mobile_variant_2_top_arrow_icon_alt?: string;
  mobile_variant_2_bottom_arrow_icon?: string;
  mobile_variant_2_bottom_arrow_icon_alt?: string;
  status?: boolean;
  variant?: string;
  metadata?: ICourseSpecialisationsMetadata[];
}

/**
 * Create course specialisations entry
 */
export async function createCourseSpecialisations(payload: Partial<ICourseSpecialisations>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.COURSE_SPECIALISATION.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update course specialisations
 */
export async function updateCourseSpecialisations(id: number, payload: Partial<ICourseSpecialisations>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.COURSE_SPECIALISATION.UPDATE(id), payload);
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get course specialisations by ID
 */
export async function getCourseSpecialisationsById(id: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.COURSE_SPECIALISATION.GET_BY_ID(id));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get course specialisations by page ID
 */
export async function getCourseSpecialisationsByPageId(pageId: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.COURSE_SPECIALISATION.GET_BY_PAGE_ID(pageId));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Delete course specialisations by ID
 */
export async function deleteCourseSpecialisationsById(id: number) {
  try {
    const response = await adminAxios.delete(ADMIN_API_ENDPOINTS.COURSE_SPECIALISATION.DELETE(id));
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
